"use strict";

import Swiper from 'swiper';
import { onReady } from '../core/ready.js';

onReady(() => {
    initExtraCustomizations();
});

function initExtraCustomizations() {
    const sliderBlocks = document.querySelectorAll('.feature-block__slider');
    sliderBlocks.forEach((sliderEl) => {
        const wrapper = sliderEl.closest('.feature-block__slider-shell');
        const navNext = wrapper?.querySelector('.swiper-button-next');
        const navPrev = wrapper?.querySelector('.swiper-button-prev');

        new Swiper(sliderEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: {
                nextEl: navNext,
                prevEl: navPrev,
            },
            breakpoints: {
                768: { slidesPerView: 2 },
                992: { slidesPerView: 3 },
                1200: { slidesPerView: 4 },
                1400: { slidesPerView: 5 },
            },
        });
    });

    const responsiveLists = document.querySelectorAll('.js-feature-block-list');
    responsiveLists.forEach((listEl) => {
        const slidesWrapper = listEl.querySelector('.feature-block__list-wrapper');
        const slides = slidesWrapper ? Array.from(slidesWrapper.children) : [];
        const navNext = listEl.querySelector('.swiper-button-next');
        const navPrev = listEl.querySelector('.swiper-button-prev');
        const mq = window.matchMedia('(max-width: 991px)');
        let instance = null;

        const enable = () => {
            if (!slidesWrapper || !slides.length) {
                return;
            }

            listEl.classList.add('swiper', 'feature-block__list--is-slider');
            slidesWrapper.classList.add('swiper-wrapper');
            slides.forEach((slideEl) => slideEl.classList.add('swiper-slide'));
            instance = new Swiper(listEl, {
                slidesPerView: 1,
                spaceBetween: 0,
                observer: true,
                observeParents: true,
                resizeObserver: true,
                navigation: {
                    nextEl: navNext,
                    prevEl: navPrev,
                }
            });
        };

        const disable = () => {
            if (instance) {
                instance.destroy(true, true);
                instance = null;
            }

            listEl.classList.remove('swiper', 'feature-block__list--is-slider');
            slidesWrapper?.classList.remove('swiper-wrapper');
            slides.forEach((slideEl) => slideEl.classList.remove('swiper-slide'));
        };

        const toggle = () => {
            if (mq.matches) {
                if (!instance) enable();
            } else {
                disable();
            }
        };

        toggle();
        mq.addEventListener('change', toggle);
    });
}
